import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { AdresBilgisiEditComponent } from './adres-bilgisi-edit.component';
import { AdresBilgisiKartComponent } from './adres-bilgisi-kart.component';

@DinamikBilesen({
  id: 'adres-bilgisi',
  baslik: 'Adres Bilgisi',
  aciklama: 'Adres bilgisi ekle',
  ikon: 'environment',
  kategori: 'personel',
})
class AdresBilgisi {
  paylas_kutusu = AdresBilgisiEditComponent;
  paylasilmis_kart = AdresBilgisiKartComponent;
}
